import { MessageBus, type Event as MessageBusEvent } from '@podium/browser';
import React from 'react';
import { EmbeddedPodlet } from '../../podlets/EmbeddedPodlet';
import { usePodlets, type EmbeddedPodletResponse } from '../../podlets/Podlets';

const MESSAGE_BUS_CHANNEL = 'pole-position';
const MESSAGE_BUS_TOPIC = 'status';

type PolePositionStatus = 'RESULT' | 'EMPTY';

type PolePositionProps = {
    className?: string;
};

export function PolePosition(props: PolePositionProps) {
    const { className = '' } = props;

    const { polePosition } = usePodlets();

    const [isHidden, setIsHidden] = React.useState(() =>
        hasEmptyContent(polePosition),
    );

    React.useEffect(function hideEmptyPolePosition() {
        function handleUpdatedStatus(ev: MessageBusEvent) {
            const status = ev.payload as PolePositionStatus;
            setIsHidden(status === 'EMPTY');
        }

        const messageBus = new MessageBus();
        messageBus.subscribe(
            MESSAGE_BUS_CHANNEL,
            MESSAGE_BUS_TOPIC,
            handleUpdatedStatus,
        );

        return () =>
            messageBus.unsubscribe(
                MESSAGE_BUS_CHANNEL,
                MESSAGE_BUS_TOPIC,
                handleUpdatedStatus,
            );
    }, []);

    const hiddenClass = isHidden ? 'hidden' : '';

    return (
        <EmbeddedPodlet
            cautiouslyReloadScriptOnHydrationError
            className={`${className} ${hiddenClass}`}
            response={polePosition}
        />
    );
}

function hasEmptyContent(podlet: EmbeddedPodletResponse) {
    return podlet.content.includes('<div id="app"></div>');
}
